@if (unavailable(); as unavailable) {
  <!-- One middle at a time: busy takes it, the branding ground stays. -->
  @if (!busy()) {
    @switch (labelMode()) {
      @case ('caption') {
        <div class="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
          <svg mib-icon [name]="unavailable.icon" [class]="iconClasses()" aria-hidden="true"></svg>
          @if (unavailable.label) {
            <p class="pt-2 text-xs/4.5 text-gray-200">{{ unavailable.label }}</p>
          }
        </div>
      }
      @case ('tooltip') {
        <div class="absolute inset-0 grid place-items-center">
          <!-- No label, no name: an image role without one fails axe. -->
          <span
            class="grid"
            [attr.role]="unavailable.label ? 'img' : null"
            [attr.aria-label]="unavailable.label || null"
            [mibTooltip]="unavailable.label ?? ''">
            <svg mib-icon [name]="unavailable.icon" [class]="iconClasses()" aria-hidden="true"></svg>
          </span>
        </div>
      }
    }
  }
} @else if (source(); as source) {
  <!-- Decorative alt: the page names the case. Two branches, since NgOptimizedImage refuses a
    priority that changes after creation (NG02953). -->
  @if (priority()) {
    <img
      [ngSrc]="source"
      fill
      alt=""
      class="object-cover"
      priority
      (load)="loadedSrc.set(source)"
      (error)="failedSrc.set(source)" />
  } @else {
    <img
      [ngSrc]="source"
      fill
      alt=""
      class="object-cover"
      (load)="loadedSrc.set(source)"
      (error)="failedSrc.set(source)" />
  }
}

@if (loading()) {
  <div class="absolute inset-0 grid place-items-center" aria-hidden="true">
    <mib-spinner color="light" [size]="metrics().spinner" />
  </div>
}

@if (busy(); as busy) {
  <!-- The wash keeps the light spinner or icon readable over any still. -->
  <div class="absolute inset-0 grid place-items-center bg-gray-900/60 px-4 text-center">
    @switch (busyMark()) {
      @case ('spinner') {
        <!-- The spinner is named by the sentence, so the caption is not read twice. -->
        <mib-spinner
          color="light"
          [size]="metrics().spinner"
          [label]="busy"
          [mibTooltip]="busy"
          [mibTooltipDisabled]="metrics().busyCaption">
          @if (metrics().busyCaption) {
            <p class="pt-2 text-xs/4.5 text-gray-200" aria-hidden="true">{{ busy }}</p>
          }
        </mib-spinner>
      }
      @case ('refresh') {
        <div class="flex flex-col items-center">
          <span
            class="grid"
            role="img"
            [attr.aria-label]="busy"
            [mibTooltip]="busy"
            [mibTooltipDisabled]="metrics().busyCaption">
            <svg mib-icon name="refresh-cw" [class]="busyIconClasses()" aria-hidden="true"></svg>
          </span>
          @if (metrics().busyCaption) {
            <p class="pt-2 text-xs/4.5 text-gray-200" aria-hidden="true">{{ busy }}</p>
          }
        </div>
      }
    }
  </div>
}
